import { render, staticRenderFns } from "./CoralCard.vue?vue&type=template&id=6d35276c"
import script from "./CoralCard.vue?vue&type=script&lang=js"
export * from "./CoralCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports